module.exports = __webpack_public_path__ + "static/media/DSC_5783.e716ab6c.JPG";